var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("We will check again in "+_vm._s(_vm.nextCheck)+"s "),_c('Interval',{on:{"onInterval":_vm.clockUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }